import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAreaPermissions } from "@/shared/hooks";
import { RippleLoader } from "@/shared/ui";

type FeatureKey =
  | "appointments"
  | "meetings"
  | "concierge"
  | "bar"
  | "events"
  | "gym"
  | "beauty"
  | "barOrders"
  | "ticketing"
  | "services"
  | "lending"
  | "messaging"
  | "externalLinks";

interface FeatureRouteProps {
  feature: FeatureKey;
  children: React.ReactNode;
}

const FeatureRoute: React.FC<FeatureRouteProps> = ({ feature, children }) => {
  const { loading, has } = useAreaPermissions();
  const location = useLocation();
  const { t } = useTranslation();

  if (loading) {
    return (
      <RippleLoader
        title={t("common.loading", "Chargement…")}
        subtitle={t(
          "permissions.loading",
          "Chargement des autorisations",
        )}
        size="medium"
      />
    );
  }

  if (!(has as any)[feature]) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default FeatureRoute;


